import { useAuthUserStore } from "../stores/authUser";
import { useSettingsStore } from "../stores/settings";
import _DatabaseModel from "./_DatabaseModel";
import { mdiAccount, mdiAccountCancel, mdiEmail, mdiIncognito } from "@mdi/js";

const USERS_TAB_ISSUES = 115;
const USERS_TAB_PERMISSIONS = 169;

class User extends _DatabaseModel {
  static model = "user";
  static editDialogComponent = "users-edit-dialog";
  static createNewObject = {
    object: { tier: null, role_ids: [], team_ids: [] },
    params: {},
  };

  static tableHeaders = [
    { textKey: "form.label.email", value: "email" },
    { textKey: "person.person", value: "person.name" },
    {
      textKey: "license.label.type",
      value: "tier",
      translationPrefix: "user.tier_types",
    },
    { textKey: "user.label.two_factor_auth", value: "otp_required_for_login" },
  ];

  static show = {
    buttons: ["edit"],
    reloadingModels: [],
  };

  static filter = {
    parts: {
      fields: [
        "email",
        "person_id",
        "tier",
        "time_filter",
        "blocked",
        "otp_required_for_login",
      ],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static operations = ["export"];

  static otp_required_for_login_options = {
    true: "filter.otp_required_for_login_levels.two_factor_auth",
    false: "filter.otp_required_for_login_levels.without_two_factor_auth",
  };

  static blocked_options = {
    true: "filter.blocked_levels.blocked",
    false: "filter.blocked_levels.not_blocked",
  };

  static tier_types = ["implementer", "admin", "full", "limited", "technical"];

  static cardFields(object) {
    return {
      src: {
        cardIcon: object.blocked ? mdiAccountCancel : mdiAccount,
        color: object.blocked ? "error" : "success",
      },
      title: object.email,
      subtitle: object.person.name,
    };
  }

  static basicInfo(object) {
    return [
      {
        labelKey: "person.person",
        value: object.person,
        type: "link",
        to: "persons",
      },
      {
        labelKey: "role.roles",
        value: object.roles,
        type: "link_array",
        to: "roles",
      },
      {
        labelKey: "team.teams",
        value: object.teams,
        type: "link_array",
        to: "teams",
      },
      {
        labelKey: "user.label.phone",
        value: object.phone,
        type: "plain",
      },
      {
        labelKey: "user.label.block_status",
        value: object.blocked,
        type: "boolean",
      },
      {
        labelKey: "user.label.two_factor_auth",
        value: object.otp_required_for_login,
        type: "boolean",
      },
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static submenuActions = [
    {
      action: "resend",
      icon: mdiEmail,
      titleKey: "user.label.submenu.resend_instructions",
      disabled: (object) => !object.permissions?.update,
      display: () => {
        const settingsStore = useSettingsStore();
        return !settingsStore.oidc;
      },
    },
    {
      action: "twoFactorAuthTurnOff",
      icon: mdiAccount,
      titleKey: "user.label.turn_2fa_off",
      disabled: (object) => !object.permissions?.update,
      display: (object) => object.otp_required_for_login,
    },
    {
      action: "impersonate",
      icon: mdiIncognito,
      titleKey: "user.label.impersonate",
      disabled: (object) => !object.permissions?.impersonate,
      display: () => {
        const authUserStore = useAuthUserStore();
        return !authUserStore.isImpersonated;
      },
    },
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static tabs = [
    this.detailTab,
    {
      titleKey: "issue.issues",
      permission: USERS_TAB_ISSUES,
      component: "IssuesTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "permission.permissions",
      permission: USERS_TAB_PERMISSIONS,
      component: "PermissionsTab",
      disabled: () => true,
    },
  ];
}

export default User;
